import React from "react";

function BudgetIcon({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 29.009 29.009" className={className}>
      <path d="M0,22.964v2.419c0,2,4.873,3.626,10.878,3.626s10.878-1.626,10.878-3.626V22.964c-2.34,1.649-6.618,2.419-10.878,2.419S2.34,24.612,0,22.964ZM18.131,7.252c6.006,0,10.878-1.626,10.878-3.626S24.136,0,18.131,0,7.252,1.626,7.252,3.626,12.125,7.252,18.131,7.252ZM0,17.02v2.924c0,2,4.873,3.626,10.878,3.626s10.878-1.626,10.878-3.626V17.02c-2.34,1.926-6.623,2.924-10.878,2.924S2.34,18.947,0,17.02Zm23.57.623c3.247-.629,5.439-1.8,5.439-3.139V12.085A13.914,13.914,0,0,1,23.57,14.04ZM10.878,9.065C4.873,9.065,0,11.094,0,13.6s4.873,4.533,10.878,4.533S21.757,16.1,21.757,13.6,16.884,9.065,10.878,9.065ZM23.3,12.255c3.4-.612,5.705-1.813,5.705-3.19V6.646C27,8.068,23.542,8.833,19.9,9.014A6.345,6.345,0,0,1,23.3,12.255Z" />
    </svg>
  );
}

export { BudgetIcon };
